'use client'

import { ReactNode } from 'react'
import { usePathname } from 'next/navigation'
import { withoutLocale } from '@/locales'

const SINGLE_PATH_PREFIXES = ['/studio', '/world']

function isSingleRoute(pathname: string | null): boolean {
  if (!pathname) return false
  const stripped = withoutLocale(pathname)
  return SINGLE_PATH_PREFIXES.some(
    (prefix) => stripped === prefix || stripped.startsWith(`${prefix}/`)
  )
}

export default function DesktopMobileRouteGate({
  children,
}: {
  children: ReactNode
}) {
  const pathname = usePathname()
  if (!isSingleRoute(pathname)) return null
  return <>{children}</>
}
